"use strict";
define(
'actions/badges',[
	"backbone",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
],
function(Backbone, AppDispatcher, Constants) {
	return Backbone.Model.extend({
		pull: function (onComplete, onFail) {
			if (!window.api) {
				throw new Error("Expected API client at [window.api].");
			}

			return window.api.request("badges")
			.execute()
			.done(function (response) {
				if (!response || !Array.isArray(response.data)) {
					console.error("Invalid response from badges endpoint.", response);
					return;
				}

				AppDispatcher.dispatch({
					actionType: Constants.ADD_BADGE,
					data: response.data
				})

				if (typeof onComplete === "function") {
					onComplete(response);
				}
			})
			.fail(function (jqXHR, textStatus, errorThrown) {
				if (typeof onFail === "function") {
					onFail(jqXHR, textStatus, errorThrown);
				}
			});
		}
	});
});
